import { store } from '../../../src/store';
import {createApp} from 'vue'
import MicroModal from 'micromodal';
import axios from "axios";


if(document.querySelector('.c-modal-login')){
	var app_courses_module = createApp({
		data(){
			return {
				checkoutComplete: false,
				tab: 0,			// 0: collegiat / 1: non-collegiat
				//clientLogged: false,
				loginData: {
					code: "",
					pass: ""
				},
				loginErrors: {
					userNotFound: false,
					passwordError: false
				},
				loginFormOpen: false,
				defaultOpen: false,
				loginLoading: false
			}
		},
		computed: {
			clientLogged(){
				return store.getters['account/clientLogged']
			},
			sessionInfo(){
				return store.getters['account/sessionInfo']
			}
		},
		watch:{
			sessionInfo: function(){
				switch (this.sessionInfo.result.statusCode) {
					case 200:

						if (location.pathname === '/club-cateb/'){

							var postData = {
								sso_email: this.sessionInfo.email,
								sso_name: this.sessionInfo.firstName,
								sso_surname: this.sessionInfo.lastName,
								sso_token: this.sessionInfo.associateNumber,
							};

							axios.post(wp_js_var.sso_url, JSON.stringify(postData))
								.then(function(response){
									window.location.href = response.data;
								} );
						}

						//this.fillLoggedData();
						if (sessionStorage.getItem('currentOutputURL')) {
							let url = "";
							url = sessionStorage.getItem('currentOutputURL');
							sessionStorage.removeItem('currentOutputURL')
							this.loginLoading = false;
							if (url != "" && url != window.location.href+"/#") {
								window.location = url;
							}else{
								location.reload();
							}
							MicroModal.close('modal-login');
							document.querySelector('body').style.overflow = "visible";
							this.loginFormOpen = false;
							this.loginData.code = "";
							this.loginData.pass = "";
						}else{
							this.loginLoading = false;
							MicroModal.close('modal-login');
							document.querySelector('body').style.overflow = "visible";
							this.loginFormOpen = false;
							this.loginData.code = "";
							this.loginData.pass = "";
						}

						let sessionURL = "/wp-content/themes/cateb/src/services/account/session.php"
						axios({
							method: "post",
							url: sessionURL,
							data: {
								'sessionStatus': "logged"
							}
						}).then(response => {
							if (location.pathname !== '/club-cateb/'){
								location.reload();
							}
						})
						break;
					case 401:
						this.loginErrors.userNotFound = true;
						this.loginLoading = false;
						break;
					case 500:
						this.loginErrors.passwordError = true;
						this.loginLoading = false;
						break;

					default:
						break;
				}
			}
		},
		mounted(){
			//console.log('initializing login modal');
			let app = this;
			MicroModal.init({
				onShow: modal => app.setModal(modal.id),
				onClose: modal => app.resetModal(modal.id)
			});
			if (document.querySelector('.c-modal-login .modal').dataset['defaultState'] == 'open') {
				app.defaultOpen = true;
				if (!app.clientLogged && !sessionStorage.getItem('loginStatus')) {
					MicroModal.show('modal-login');
					document.querySelector('body').style.overflow = "hidden";
				}
			}
		},
		methods:{
			logClient: function(event){

				event.preventDefault();
				console.log('Login click')
				let app = this;
				app.loginLoading = true;
				this.loginErrors = {
					userNotFound: false,
					passwordError: false
				};
				let url = '/wp-content/themes/cateb/src/services/account/login.php'
					+"?code="+app.loginData.code
					+"&pass="+app.loginData.pass;
				//console.log(url);
				store.dispatch('account/tryLogin', url);
				//store.dispatch('account/forceLogin');
			},
			loginBtnEnabled: function(){
				if (this.loginData.code == "" || this.loginData.pass == "") {
					return 'c-btn--disabled';
				}else{
					return '';
				}
			},
			toggleLoginView: function(){
				this.loginFormOpen = !this.loginFormOpen;
			},
			setModal: function(id){
				document.querySelector('body').style.overflow = "hidden";
			},
			resetModal: function(id){
				document.querySelector('body').style.overflow = "inherit";
				if(id=="modal-login"){
					this.loginFormOpen = false;
					this.loginData.code = "";
					this.loginData.pass = "";
				}
			}
		}
	}).mount(document.querySelector('.c-modal-login'));
}
